import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import DJPalDateRangeModal from './DJPalDateRangeModal';

// Mobile presentation of the date-range picker: the same DJPalDateRangeModal,
// portaled into a bottom sheet instead of the desktop's anchored popover
// (which clips and crowds at phone widths). Backdrop tap closes without
// clearing an applied range — same semantics as the popover's outside click.
function DateRangeSheet({ dateRange, onApply, onClose }) {
    // The sheet overlays the whole viewport; don't let the page scroll under it.
    useEffect(() => {
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = prev; };
    }, []);

    // Android system Back closes the sheet. App.js's global backButton
    // handler deliberately no-ops while a [role="dialog"] is open — open
    // overlays are expected to register their own listener, so do.
    useEffect(() => {
        const App = window.Capacitor?.Plugins?.App;
        if (!App?.addListener) return undefined;
        let handle = null;
        const sub = App.addListener('backButton', onClose);
        Promise.resolve(sub).then((h) => { handle = h; });
        return () => { try { handle?.remove?.(); } catch { /* noop */ } };
    }, [onClose]);

    return ReactDOM.createPortal(
        <div className="djpal-date-sheet-backdrop" onClick={onClose}>
            <div
                className="djpal-date-sheet"
                role="dialog"
                aria-label="Date range"
                onClick={(e) => e.stopPropagation()}
            >
                <DJPalDateRangeModal dateRange={dateRange} onApply={onApply} onClose={onClose} />
            </div>
        </div>,
        document.body
    );
}

export default DateRangeSheet;
